module.exports = __webpack_public_path__ + "img/3.3c5341d7.webp";